import { useState, type ReactNode } from "react";
import { PaywallModal } from "./PaywallModal";
import "./paywall.css";

export interface PaywallOverlayProps {
  locked: boolean;
  featureTitle?: string;
  portalUrl?: string;
  children: ReactNode;
}

export function PaywallOverlay({
  locked,
  featureTitle,
  portalUrl,
  children,
}: PaywallOverlayProps) {
  const [modalOpen, setModalOpen] = useState(false);

  return (
    <>
      <div
        className={
          locked ? "jari-paywall-wrap jari-paywall-wrap--locked" : "jari-paywall-wrap"
        }
      >
        <div className="jari-paywall-wrap__content">{children}</div>
        {locked && (
          <button
            type="button"
            className="jari-paywall-overlay jari-paid-locked"
            onClick={() => setModalOpen(true)}
            aria-label="Licentie vereist: meer informatie"
          />
        )}
      </div>
      <PaywallModal
        open={modalOpen}
        onClose={() => setModalOpen(false)}
        featureTitle={featureTitle}
        portalUrl={portalUrl}
      />
    </>
  );
}
